export const INVOICE_CREATION_STEPS = Object.freeze({
  settings: 0,
  content: 1,
  completed: 2,
} satisfies Record<string, number>);

export type InvoiceCreationStep = typeof INVOICE_CREATION_STEPS[keyof typeof INVOICE_CREATION_STEPS];